<template>
  <div class="paySuccess" v-if="rowInfo">
    <nav-header module="支付"></nav-header>
    <div class="container">
      <i class="el-icon-success"></i>
      <div class="tip">支付成功!</div>
      <count-down
        v-if="rowInfo.ContentType == 1 && rowInfo.IsShowCountDown"
        :startTime="startTime"
        :endTime="time"
      ></count-down>
      <!-- <p class="desc">您已成功支付￥39.90。</p> -->
      <p
        class="desc"
        v-if="
          rowInfo.ContentType == 1 &&
          !rowInfo.IsProjectJob &&
          rowInfo.IsShowCountDown
        "
      >
        恭喜您发单成功！速派承诺发单后，4小时响应时间，请您耐心等候。
      </p>
      <p
        class="desc"
        v-if="
          rowInfo.ContentType == 1 &&
          !rowInfo.IsProjectJob &&
          rowInfo.IsShowCountDown
        "
      >
        备注：4小时响应：早上8点至晚8点结束（含周末，不含法定节假日）
      </p>
      <template
        v-if="
          rowInfo.SendJobUserCode == 'e' + userInfo.CompanyId ||
          rowInfo.SendJobUserCode == 'p' + userInfo.LoginAccountId
        "
      >
        <button
          v-if="rowInfo.ContentType == 1"
          class="btn-primary"
          @click="
            $router.replace({
              path: '/createOrderProcess',
              query: { jobNo: rowInfo.JobNo },
            })
          "
        >
          查看工单
        </button>
        <button v-else class="btn-primary" @click="$router.go(-1)">返回</button>
      </template>
      <template v-else>
        <button class="btn-primary" @click="$router.replace({ path: '/home' })">
          返回
        </button>
      </template>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import navHeader from "@/components/navHeader.vue";
import CountDown from "@/components/countdown.vue";
import {
  GetPayResultInfo, //获取信息回调
} from "@/scripts/api.js";
export default {
  components: {
    navHeader,
    CountDown,
  },
  data() {
    return {
      time: 0,
      jobNo: 0,
      jobType: 0,
      startTime: new Date().getTime(),
      payId: "",
      rowInfo: {},
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  created() {
    this.payId = this.$route.query.payId;
    this.GetPayResultInfoFun();
  },
  methods: {
    GetPayResultInfoFun() {
      let data = {};
      data.payId = this.payId;
      console.log(data);
      GetPayResultInfo(data).then((res) => {
        this.rowInfo = res.Data;
        console.log(res.Data);
        if (res.Data.ContentType == 1) {
          let startTime =new Date(res.Data.ReleaseDate).getTime() || new Date().getTime(); //支付成功时间
          let hour = this.rowInfo.ResponseHour || 4; //响应时长
          this.time = startTime + hour * 60 * 60 * 1000; //回应时间
        }
      });
    },
  },
};
</script>
<style lang="scss">
.paySuccess {
  background-color: #f9f9f9;
  min-height: 100vh;
  overflow: hidden;
  .container {
    width: 1000px;
    margin: 0px auto;
    padding-top: 68px;
    overflow: hidden;
    text-align: center;
    .el-icon-success {
      font-size: 64px;
      color: green;
      margin-bottom: 10px;
      margin-top: 100px;
    }
    .tip {
      font-size: 30px;
      font-weight: bold;
      color: #666;
      line-height: 1.5;
    }
    .countdown {
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .desc {
      font-size: 14px;
      line-height: 24px;
      margin-bottom: 10px;
      color: #999;
    }
    .btn-primary {
      width: 100px;
      height: 30px;
      border-radius: 2px;
      font-size: 14px;
      margin-top: 40px;
      cursor: pointer;
    }
  }
}
</style>